import React, { useState, useEffect } from "react";
import throttle from "lodash/throttle";

export var useScrollEvent = function useScrollEvent() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$offset = config.offset,
      offset = _config$offset === undefined ? 10 : _config$offset,
      _config$fromBottom = config.fromBottom,
      fromBottom = _config$fromBottom === undefined ? false : _config$fromBottom,
      _config$triggerOnce = config.triggerOnce,
      triggerOnce = _config$triggerOnce === undefined ? false : _config$triggerOnce,
      _config$onPass = config.onPass,
      onPass = _config$onPass === undefined ? function () {} : _config$onPass,
      _config$onReverse = config.onReverse,
      onReverse = _config$onReverse === undefined ? function () {} : _config$onReverse;

  var _useState = useState(true),
      toggle = _useState[0],
      setToggle = _useState[1];

  var _useState2 = useState(0),
      scroll = _useState2[0],
      setScroll = _useState2[1];

  useEffect(function () {
    if (toggle) {
      onReverse();
    } else {
      onPass();
    }
  }, [toggle]);

  // ON LOAD:
  useEffect(function () {
    var scrollY = window.pageYOffset;
    setScroll(scrollY);
    if (scrollY > offset) setToggle(false);
    // set up scroll listener
    window.addEventListener("scroll", handleScroll, { passive: true });
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  var handleScroll = throttle(function (e) {
    var scrollY = window.pageYOffset;
    setScroll(scrollY);
    var triggerY = offset;

    // offsets of below 1 are interpreted as percentage values
    if (triggerY > 0 && triggerY <= 1) {
      triggerY = document.documentElement.scrollHeight * triggerY;
    }

    // trigger when popping up at bottom of screen instead of top
    if (fromBottom) {
      var bodyHeight = document.body.clientHeight;
      var clientHeight = document.documentElement.clientHeight;
      triggerY = bodyHeight - triggerY - clientHeight;
    }

    if (scrollY >= triggerY) {
      // ON BELOW:
      setToggle(false);
    } else if (!triggerOnce && scrollY < triggerY) {
      // ON ABOVE:
      setToggle(true);
    }
  }, 100);

  return { toggle: toggle, scroll: scroll };
};